var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0152 6.34074C22.146 4.40737 24.9403 4.40737 26.0712 6.34074L30.0154 13.084C30.4189 13.7739 31.0869 14.269 31.8645 14.4542L39.4427 16.2601C41.5646 16.7657 42.4089 19.3303 41.0023 20.9975L35.8195 27.1405C35.3189 27.7338 35.0743 28.5017 35.1396 29.2752L35.8162 37.2963C36.0026 39.5062 33.7606 41.1133 31.7276 40.2272L24.7134 37.1697C23.9672 36.8445 23.1192 36.8445 22.3729 37.1697L15.3587 40.2272C13.3258 41.1133 11.0838 39.5061 11.2702 37.2963L11.9468 29.2752C12.012 28.5017 11.7675 27.7338 11.2669 27.1405L6.08408 20.9975C4.67749 19.3303 5.52177 16.7657 7.64363 16.2601L15.2219 14.4542C15.9994 14.269 16.6674 13.7739 17.071 13.084L21.0152 6.34074Z",
    stroke: "#0B5ED7",
    strokeWidth: 5.06733
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.ad43ca11ab40735799a823de7ee5af1d.svg";
export { ForwardRef as ReactComponent };